/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';

import { AlertAdapter, CommonDropdown, DatePicker, ICommonDropdownOption } from 'pg-ui-library';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useActions } from 'src/hooks/useActions';
import { DateTime } from 'luxon';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { createFileDetails, parseFileDetailsToFile } from 'src/utils/fileConvert';
import { Container, DocumentsButton, FlexContainer } from './styles';
import { QleDocumentsModal } from '../qle-documents-modal';
import { QLEType, useSetQle } from '../../enrollment.context';
import './index.css';

export const qleLifeEvents = [
  'Loss of coverage (employee or dependent)',
  'Divorce or separation',
  'Marriage',
  'Dependent is no longer in school',
  'Change in employee group (full time to part time, part time to full time)',
  'Birth, adoption, custody, or legal guardianship of a child',
  'Death',
  'Change in eligibility for Medicare, Medicaid, or State CHIP program',
  'Other',
];

export const dropdownOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: qleLifeEvents[0],
    value: qleLifeEvents[0],
  },
  {
    key: '2',
    label: qleLifeEvents[1],
    value: qleLifeEvents[1],
  },
  {
    key: '3',
    label: qleLifeEvents[2],
    value: qleLifeEvents[2],
  },
  {
    key: '4',
    label: qleLifeEvents[3],
    value: qleLifeEvents[3],
  },
  {
    key: '5',
    label: qleLifeEvents[4],
    value: qleLifeEvents[4],
  },
  {
    key: '6',
    label: qleLifeEvents[5],
    value: qleLifeEvents[5],
  },
  {
    key: '7',
    label: qleLifeEvents[6],
    value: qleLifeEvents[6],
  },
  {
    key: '8',
    label: qleLifeEvents[7],
    value: qleLifeEvents[7],
  },
  {
    key: '9',
    label: qleLifeEvents[8],
    value: qleLifeEvents[8],
  },
];

const QualifyingLifeEventDetails: React.FC = () => {
  const { setQLEFiles } = useActions();
  const { qleFiles } = useTypedSelector(state => state.benefits.data);

  // const [eventType, setEventType] = useState<EnrollmentTypes>('qle');

  const [documentsModalIsOpen, setDocumentsModalIsOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars

  const [qleData, setQleData] = useLocalStorage('qleData', null);

  const setQle = useSetQle();

  const validationSchema = yup.object().shape({
    eventType: yup.string(),
    eventDate: yup.string(),
    lifeEvent: yup.string(),
    description: yup.string(),
    files: yup.mixed().test('type', 'We only support .png .jpg .jpeg .pdf', value => {
      const validDocs = [];
      if (value) {
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < value.length; index++) {
          const file = value[index];
          if (
            file.type.includes('application/pdf') ||
            file.type.includes('image/png') ||
            file.type.includes('img/jpg') ||
            file.type.includes('img/jpeg')
          ) {
            validDocs.push(file);
          }
        }
        return validDocs.length === value.length;
      }
      return true;
    }),
  });

  const formik = useFormik<QLEType>({
    initialValues: {
      eventType: qleData?.eventType ? qleData?.eventType : 'qle',
      eventDate: qleData?.eventDate ? new Date(qleData?.eventDate) : new Date(),
      lifeEvent: qleData?.lifeEvent ? qleData?.lifeEvent : dropdownOptions[0].value,
      description: qleData?.description ? qleData?.description : '',
      files: null,
    },
    validationSchema,

    onSubmit: values => {
      const isEventInEligiblePeriod = checkEligiblePeriod();
      setQle({ ...values, isEventInEligiblePeriod });
      setQleData({ ...values, isEventInEligiblePeriod });
    },
  });

  const setFiles = async (f: FileList | []) => {
    formik.setFieldValue('files', f);
    // Salvar arquivos em URL
    if (f) {
      const fileList: unknown[] = [];
      for (let index = 0; index < f.length; index++) {
        const file = f[index];
        if (file) {
          const r = await createFileDetails(file);

          fileList.push(r);
        }
      }

      setQLEFiles(fileList);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [saving, setIsSaving] = useState(false);
  const debounceMs = 1000;

  useEffect(
    () => {
      // Update debounced value after delay
      setIsSaving(true);
      const handler = setTimeout(() => {
        formik.submitForm().then(() => setIsSaving(false));
      }, debounceMs);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [formik.values, debounceMs] // Only re-call effect if value or delay changes
  );

  function checkEligiblePeriod(): boolean {
    if (formik.values?.eventDate) {
      const eventDate = DateTime.fromJSDate(formik.values?.eventDate as Date);

      if (formik.values.lifeEvent === qleLifeEvents[7]) {
        const eventDatePlus60Days = eventDate.plus({ days: 60 });
        const currentDate = DateTime.now();

        if (eventDatePlus60Days < currentDate) {
          AlertAdapter(
            'Medical QLE claims can only be made within 60 days of the event. Your request will be reviewed by an Admin whom may decline the claim solely based on this.',
            'warning'
          );
          return false;
        }
      } else {
        const eventDatePlus30Days = eventDate.plus({ days: 30 });
        const currentDate = DateTime.now();

        if (eventDatePlus30Days < currentDate) {
          AlertAdapter(
            'Important: You have 30 days after the QLE date to report the event, make election changes, and upload the supporting documentation. If the event is not reported and documentation not received within that timeframe, you will not be allowed to make changes.',
            'warning'
          );
          return false;
        }
      }
    }

    return true;
  }

  const loadedfiles: File[] = [];
  useEffect(() => {
    if (qleFiles) {
      qleFiles.forEach((data: unknown) => {
        const parsedFile = parseFileDetailsToFile(data);
        loadedfiles.push(parsedFile);
      });

      // if (fileInputRef.current && loadedfiles) {
      if (loadedfiles) {
        const updatedFileList = Array.from(loadedfiles);

        // Create a new DataTransfer object
        const newDataTransfer = new DataTransfer();

        // Add files to the DataTransfer object
        updatedFileList.forEach((file: File) => {
          newDataTransfer.items.add(file);
        });

        formik.setFieldValue('files', loadedfiles);
      }
    }
  }, [qleFiles?.length]);

  return (
    <Container onSubmit={formik.handleSubmit}>
      <QleDocumentsModal
        isOpen={documentsModalIsOpen}
        onClose={f => {
          formik.handleSubmit();
          setDocumentsModalIsOpen(false);
          setFiles(f);
        }}
      />

      <>
        <FlexContainer>
          <div style={{ flex: '1' }}>
            <CommonDropdown
              selectStyle={{ minWidth: '100%' }}
              data-testid="qle-event-type-dropdown"
              id="lifeEvent"
              name="lifeEvent"
              label="Life Event*"
              value={formik.values.lifeEvent}
              setValue={(val: string) => formik.setFieldValue('lifeEvent', val)}
              options={dropdownOptions}
            />
          </div>
          <div style={{ flex: '1' }}>
            <DatePicker
              data-testid="qle-event-datepicker"
              id="eventDate"
              name="eventDate"
              label="Event Date*"
              dateFormat="MM/dd/yyyy"
              selected={formik.values.eventDate as Date}
              onChange={(val: Date) => {
                formik.setFieldValue('eventDate', val);
              }}
            />
          </div>
          <div style={{ flex: 1, alignSelf: 'flex-end' }}>
            <DocumentsButton
              key={formik.values.files ? formik.values.files.length : 0}
              type="button"
              onClick={() => setDocumentsModalIsOpen(true)}
            >
              {` ${
                formik.values.files?.length ? formik.values.files?.length : 0
              } Document(s) Attached Click to Save/Edit*`}
            </DocumentsButton>
          </div>
        </FlexContainer>
        <FlexContainer>
          <p style={{ margin: '0' }}>Description*</p>
        </FlexContainer>
        <FlexContainer style={{ flex: '1' }}>
          <textarea
            data-testid="qle-event-textarea"
            id="description"
            name="description"
            rows={5}
            style={{ width: '80%', backgroundColor: '#fff' }}
            value={formik.values.description}
            onChange={formik.handleChange}
          />
        </FlexContainer>
        {/*
          <FlexContainer>
            <p>{saving ? 'Saving...' : 'Changes saved.'}</p>
          </FlexContainer>
              */}
      </>
    </Container>
  );
};

export default QualifyingLifeEventDetails;
